import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { colorPalettePresets  } from 'components/explore/gmap/colorHelper';

export const initialState = {
  geoType: "",
  selectedShapeId: null,
  selectedShapeObjectId: null,
  shapesDataObjects: {}
}

const shapesDataObjectState = {
  shapesData: [],
  dataGeoType: null,
  coloringType: "MedianIncome",
  requestedGeoType: null,
  isVisible: true,
  isLoading: false,
  isErrored: false,
  customPalette: {
    c0: "#ecec37",
    c1: "#90e0dd",
    c2: "#5986d6"
  },
  fillOpacity: 0.7,
  strokeWeight: 1
}

const slice = createSlice({
  name: 'exploreShapesDataSlice',
  initialState,
  reducers: {
    createExploreShapesDataObjectInstance: (state, action) => {
      const obj = action.payload;
      state.shapesDataObjects[obj.id] = {
        ...shapesDataObjectState,
        index: obj.index,
        isVisible: obj.visible,
        requestedGeoType: obj.geoLevel,
        coloringType: obj.shapeLabel,
        customPalette: obj.customPalette ?? colorPalettePresets.find(el => el.id === obj.shapeColorPaletteId),
        fillOpacity: obj.fillOpacity,
        strokeWeight: obj.strokeWeight
      }
    },
    deleteExploreShapesDataObjectInstance: (state, action) => {
      const id = action.payload;
      delete state.shapesDataObjects[id];
    },
    setExploreShapesDataObjects: (state, action) => {
      state.shapesDataObjects = action.payload;
    },
    updateExploreShapesDataObjectById: {
      reducer: (state, action) => {
        const { objectId, update } = action.payload;
        state.shapesDataObjects[objectId] = {
          ...state.shapesDataObjects[objectId],
          ...update
        } 
      },
      prepare: (objectId, update) => ({ payload: { objectId, update } })
    },
    setExploreSelectedShapeId: { //
      reducer: (state, action) => {
        // state.shapesDataObjects[action.payload.objectId].selectedShapeId = action.payload.selectedShapeId;
        state.selectedShapeId = action.payload.selectedShapeId;
        state.selectedShapeObjectId = action.payload.objectId;
      },
      prepare: (objectId, selectedShapeId, shouldSelectPin) => ({ payload: { objectId, selectedShapeId, shouldSelectPin }})
    },
    setExploreShapesData: { //
      reducer: (state, action) => {
        state.shapesDataObjects[action.payload.objectId].shapesData = action.payload.shapesData;
        state.shapesDataObjects[action.payload.objectId].dataGeoType = action.payload.dataGeoType;
      },
      prepare: (objectId, shapesData, dataGeoType) => ({ payload: { objectId, shapesData, dataGeoType} })
    },
    setExploreShapesColoringType: {
      reducer: (state, action) => {
        state.shapesDataObjects[action.payload.objectId].coloringType = action.payload.shapesColoringType;
      },
      prepare: (objectId, shapesColoringType) => ({ payload: { objectId, shapesColoringType } })
    },
    setExploreShapesRequestedGeoType: {
      reducer: (state, action) => {
        state.shapesDataObjects[action.payload.objectId].requestedGeoType = action.payload.requestedGeoType;
      },
      prepare: (objectId, requestedGeoType) => ({ payload: { objectId, requestedGeoType } })
    },
    setExploreShapesIsVisible: {
      reducer: (state, action) => {
        state.shapesDataObjects[action.payload.objectId].isVisible = action.payload.isVisible;
      },
      prepare: (objectId, isVisible) => ({ payload: { objectId, isVisible } })
    },
    setExploreShapesIsLoading: {
      reducer: (state, action) => {
        state.shapesDataObjects[action.payload.objectId].isLoading = action.payload.isLoading;
      },
      prepare: (objectId, isLoading) => ({ payload: { objectId, isLoading } })
    },

    // Redux saga actions, no reducers
    fetchExploreShapesData: () => { }, // Triggers exploreShapesDataSaga
  }
});

export const exploreShapesDataActions = slice.actions;
export default slice.reducer;

// Memoized selectors
export const exploreShapesDataSelectors = {
  shapesDataParamsSelector: createSelector(
    [state => state.exploreMap, (state, objectId) => state.exploreShapesData.shapesDataObjects[objectId]],
    (exploreMap, shapesDataObject) => {
      const { bounds, zoom } = exploreMap;
      const { requestedGeoType, isErrored } = shapesDataObject;
      return {
        bounds,
        zoom,
        requestedGeoType,
        isErrored
      };
    }
  )
}